<div class="active-filters" *ngIf="count">
  <span class="active-filters--dot"></span>
  <span>
    {{ count | castNumber | activeFilter }}
  </span>
</div>
